(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SecureStore", [], factory);
	else if(typeof exports === 'object')
		exports["SecureStore"] = factory();
	else
		root["SecureStore"] = factory();
})(window, function() {
return 